const socialColors = { github: '#000', facebook: '#3b5999', twitter: '#0f1419', medium: '#444', linkedin: '#2867B2' };

export { socialColors };
